import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import UpdateFeed from '@/pages/home/components/UpdateFeed';
import HotPicks from '@/pages/home/components/HotPicks';
import SeriesZone from '@/pages/home/components/SeriesZone';
import RankBoard from '@/pages/home/components/RankBoard';
import CategoryFilter from '@/pages/home/components/CategoryFilter';
import WatchGuide from '@/pages/home/components/WatchGuide';
import AboutSection from '@/pages/home/components/AboutSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <UpdateFeed />
        <HotPicks />
        <SeriesZone />
        <RankBoard />
        <CategoryFilter />
        <WatchGuide />
        <AboutSection />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}